const API_URL = process.env.VUE_APP_API_URL
const getToken = () => localStorage.getItem('access-token')

export default {
  async getPricingParamsDBAPI () {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/pricing-params`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })

    let resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async updatePricingParamsDBAPI (params) {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/pricing-params`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify(params)
    })

    const resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      } else {
        throw new Error('Error desconocido al actualizar parámetros')
      }
    }

    return resp
  },
  async getMarketPricesDBAPI () {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/list`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })

    let resp = await response.json()

    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async csvDownloadMarketPricesDBAPI () {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/getcsv`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })

    let resp = await response.json()

    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async csvEditTemplateMarketPricesDBAPI () {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/edit-template`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })

    let resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async bulkUpdateMarketPricesDBAPI (updates) {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/bulk-edit`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify({ updates })
    })

    const resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      } else {
        throw new Error('Error desconocido al actualizar precios')
      }
    }

    return resp
  },
  async updateMarketPriceDBAPI (id, median) {
    const response = await fetch(`${API_URL}/v5/admin/market-prices/edit`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify({ id, median })
    })

    const resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      } else {
        throw new Error('Error desconocido al actualizar el precio')
      }
    }

    return resp
  }
}
